import React from "react";

const Hospitals = () => {
    return (
        <div class="dc-tabscontent tab-content">
            <div class="dc-hospsettinghold tab-pane active fade show" id="dc-security">
                <div class="dc-hospsettings dc-tabsinfo dc-tabsinfo-mt">
                    <div class="dc-tabscontenttitle dc-titlewithicon">
                        <h3>Saved hosptials</h3>
                    </div>
                    <div class="dc-docsettingscontent dc-sidepadding">
                        <div class="dc-searchresult-grid dc-searchresult-list dc-searchvlistvtwo">
                            <div class="dc-emptydata-holder">
                                <div class="dc-emptydata">
                                    <div class="dc-emptydetails dc-empty-saved-hospitals">
                                        <span></span>
                                        <em>No saved hospitals or location yet.</em>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>			
        </div>
    );
};

export default Hospitals;
